import React from "react";
import { Redirect } from "react-router-dom";

//Invoices
import InvoicesList from "../pages/Invoices/invoices-list";
import InvoiceDetail from "../pages/Invoices/invoices-detail";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
// Dashboard
import Dashboard from "../pages/Dashboard/index";

//Pages
import PagesComingsoon from "../pages/Utility/pages-comingsoon";
import PagesFaqs from "../pages/Utility/pages-faqs";
import AccountsRecievable from "pages/Dashboard/AccountsRecievable";
import LatestTranaction from "pages/Dashboard/LatestTranaction";
//???????????????????????????? Digi Lab
import LabsList from "../pages/Labs/LabsList";
import LabOverview from "../pages/Labs/LabOverview";
import PendingVerifications from "pages/Labs/PendingVerifications";
import VerifiedLabs from "pages/Labs/viewverifiedlabs";
import LabProfile1 from "pages/Labs/editprofile";

//Tests
import TestsList from "pages/Tests/TestsList";
import CreateTest from "pages/Tests/CreateTest";
import TestDetails from "pages/Tests/TestDetails";
import TestOverview from "pages/Tests/TestOverview";

//Staff
import StaffList from "pages/Staff/StaffList";
import CreateStaff from "pages/Staff/CreateStaff";
import StaffDetails from "pages/Staff/StaffDetails";
import ComplaintList from "pages/feedback,help and support/patientcomplaints";
import BlockedLabs from "pages/Labs/blockedlabs";

//ADMIN FA
import Donations from "pages/FinancialAid(Admin)/Donations";
import ApprovedFAList from "pages/FinancialAid(Admin)/ApprovedFAList";
import ApprovedFADetails from "pages/FinancialAid(Admin)/ApprovedFADetails";

import Notifications from "pages/Notifications/ViewAllNotifications";

// import List2 from "pages/Tests/List2";

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/accountspayable", component: LatestTranaction },
  { path: "/accountsrecievable", component: AccountsRecievable },

  //Invoices
  { path: "/invoices-list", component: InvoicesList },
  { path: "/invoices-detail", component: InvoiceDetail },
  { path: "/invoices-detail/:id", component: InvoiceDetail },

  //Utility
  { path: "/pages-faqs", component: PagesFaqs },

  // DigiLab
  //Lab
  { path: "/labslist", component: LabsList },
  { path: "/lab-overview/:email", component: LabOverview }, //verification details
  { path: "/pendingverifications", component: PendingVerifications },
  { path: "/verifiedlabs", component: VerifiedLabs },
  { path: "/blockedlabs", component: BlockedLabs },
  // { path: "/registerservice", component: RegisterServices },
  { path: "/editprofile", component: LabProfile1 },

  //Tests
  { path: "/createtest", component: CreateTest },
  { path: "/TestOverview/:id", component: TestOverview },
  // { path: "/edittest/:id", component: EditTest},
  // {path: "/registertest", component: RegisterTest},
  // { path: "/list2", component: List2 },
  { path: "/testslist", component: TestsList },

  //Staff
  { path: "/stafflist", component: StaffList },
  { path: "/registerstaff", component: CreateStaff },
  { path: "/staffdetails/:id", component: StaffDetails },
  { path: "/patientcomplaints", component: ComplaintList },

  //Financial Aid Admin
  { path: "/donations", component: Donations },
  { path: "/financialaid", component: ApprovedFAList },
  { path: "/financialaiddetails/:id", component: ApprovedFADetails },

  { path: "/notifications", component: Notifications },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },

  { path: "/pages-comingsoon", component: PagesComingsoon },

  // Authentication Inner

  // Digi Lab
];

export { authProtectedRoutes, publicRoutes };
